//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { MultiCheck } from '../../components/ui/multi-check/MultiCheck';
import { MultiOption } from '../../components/ui/multi-check/Option';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import Button from 'src/onboarding/components/ui/button/Button';

function Page() {
  const preferences = useStore((state) => state.preferences);
  const setPreferences = useStore((state) => state.setPreferences);

  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.preferences.title')}</Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <Check
          defaultValue={preferences}
          onChange={(value) => {
            setPreferences(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'preferences',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'No any preferences'}>
            <span>🙂</span>
            {t('onboarding.preferences.options.noAnyPreferences')}
          </Option>
          <Option value={'Vegetarian'}>
            <span>🥬</span>
            {t('onboarding.preferences.options.vegetarian')}
          </Option>
          <Option value={'Pescatarian'}>
            <span>🍤</span>
            {t('onboarding.preferences.options.pescatarian')}
          </Option>
          <Option value={'Vegan'}>
            <span>🌱</span>
            {t('onboarding.preferences.options.vegan')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
